import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { useState } from 'react';
import { IoIosSend } from 'react-icons/io';
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
import { useEffect } from 'react';

export const Form = () => {
  const form = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [alreadySended, setAlreadySended] = useState(false);

  const successSend = () => {
    setIsSuccess(true);
    setTimeout(setIsLoading(false), 5000);
  };

  const errorSend = () => {
    setIsError(true);
    setTimeout(setIsLoading(false), 5000);
  };

  const resetField = () => {
    form.current.value = '';
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setIsLoading(true);
    console.log(form.current);

    emailjs
      .sendForm(
        'service_jzggudo',
        'template_vwir187',
        form.current,
        '8UuQ4vNiDbBzhlPI8'
      )
      .then(
        (result) => {
          console.log(result.text);
          successSend();
          setAlreadySended(true);
        },
        (error) => {
          console.log(error.text);
          errorSend();
        }
      );
  };

  return (
    <div className="relative">
      {isLoading ? (
        <div className="absolute z-10 flex items-center justify-center w-full h-full bg-black/25">
          <div className="flex flex-col items-center justify-center text-white bg-gray-800 border shadow-md w-44 aspect-square rounded-2xl">
            {isSuccess ? (
              <>
                <AiOutlineCheck size={40} className="fill-green-500" />
                <p className="mt-4 font-bold">Messaggio inviato!</p>
              </>
            ) : isError ? (
              <>
                <AiOutlineClose size={40} className="fill-red-500" />
                <p className="mt-4 font-bold text-center">
                  Ops... c'è stato un errore, riprova!
                </p>
              </>
            ) : (
              <>
                <IoIosSend size={40} className="animate-pulse" />
                <p className="mt-4 font-bold animate-pulse">
                  Invio in corso...
                </p>
              </>
            )}
          </div>
        </div>
      ) : null}
      <form
        ref={form}
        onSubmit={sendEmail}
        className={`space-y-4 ${isLoading ? 'blur-sm' : ''}`}
      >
        <div>
          <label class="sr-only" for="contact_name">
            Nome e Cognome
          </label>
          <input
            class="w-full rounded-lg border-2 border-gray-400 p-3 text-sm"
            placeholder="Nome e Cognome"
            type="text"
            name="contact_name"
          />
        </div>
        <div>
          <label class="sr-only" for="contact_company">
            Azienda
          </label>
          <input
            class="w-full rounded-lg border-2 border-gray-400 p-3 text-sm"
            placeholder="Azienda"
            type="text"
            name="contact_company"
          />
        </div>

        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <label class="sr-only" for="contact_email">
              Email
            </label>
            <input
              class="w-full rounded-lg border-2 border-gray-400 p-3 text-sm"
              placeholder="Email"
              type="email"
              name="contact_email"
            />
          </div>

          <div>
            <label class="sr-only" for="contact_phone">
              Phone
            </label>
            <input
              class="w-full rounded-lg border-2 border-gray-400 p-3 text-sm"
              placeholder="Numero di telefono"
              type="tel"
              name="contact_phone"
            />
          </div>
        </div>
        <div>
          <label class="sr-only" for="message">
            Message
          </label>
          <textarea
            class="w-full rounded-lg border-2 border-gray-400 p-3 text-sm resize-none"
            placeholder="Messaggio"
            rows="8"
            name="contact_message"
          ></textarea>
        </div>
        <input
          type="submit"
          value="Invia messaggio"
          className='inline-flex items-center justify-center w-full px-5 py-3 text-blue-500 transition-all border-2 border-blue-500 rounded-lg cursor-pointer hover:bg-blue-500 hover:text-white sm:w-auto"'
        />
      </form>
    </div>
  );
};
